import React, {
  FC, useEffect, useState,
} from 'react';
import {
  Button,
} from './Styles';
import Header from '../../../../Common/Header';
import ComingSoonModal from '../../../../Common/ComingSoonModal';
import NoFreeBoxModal from '../../../../Common/NoFreeBoxModal';
import Logo from '../../../../Common/Logo';
import PlatformLayout from '../../../../Common/PlatformLayout';

const SelectPlatform: FC<Props> = ({
  cabId32Str,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  selectedPlatform,
  setSelectedPlatform,
}) => {
  const [showNoFreeBoxModal, setShowNoFreeBoxModal] = useState<boolean>();
  const [showComingSoonModal, setShowComingSoonModal] = useState<boolean>();

  useEffect(() => {
    if (selectedPlatform != null) {
      // 其他平台使用房间号取餐
      if ([3, 4, 5, 6].includes(selectedPlatform)) {
        setTargetPage('room-num-open-box');
      }
      else {
        // 熊猫平台、饭团平台延用以前的取餐码逻辑
        setTargetPage('pickup-code-open-box');
      }
    }
  }, [selectedPlatform]);

  return (
    <>
      {
        showComingSoonModal && (
          <ComingSoonModal onClose={() => setShowComingSoonModal(false)} isEnglish={isEnglish} />
        )
      }
      {
        showNoFreeBoxModal && (
          <NoFreeBoxModal onClose={() => setShowNoFreeBoxModal(false)} isEnglish={isEnglish} />
        )
      }
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={setTargetPage}
      />

      {/* Logo */}
      <Logo setTargetPage={setTargetPage} backToPage={'home'} />

      {/* 标题 */}
      {
        isEnglish ? (
          <div style={{ fontSize: '20px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '21px', textAlign: 'center', marginTop: '18px', opacity: 0.6 }}>
            Select your platform
          </div>
        ) : (
          <div style={{ fontSize: '20px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '21px', textAlign: 'center', marginTop: '18px', opacity: 0.6 }}>
            请选择您的点餐平台
          </div>
        )
      }

      {/* 商家列表 */}
      <PlatformLayout isEnglish={isEnglish} callback={setSelectedPlatform} />

      {/* 分割线 */}
      <div style={{ height: '1px', background: '#D8D8D8', width: '316px', margin: '34px auto 10px auto' }}></div>

      {/* 标题 */}
      {
        isEnglish ? (
          <div style={{ marginTop: '23px', textAlign: 'center', fontSize: '16px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '21px', opacity: 0.6 }}>
            Peer to peer
          </div>
        ) : (
          <div style={{ marginTop: '23px', textAlign: 'center', fontSize: '16px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '21px', opacity: 0.6 }}>
            个人租赁
          </div>
        )
      }

      {/* 直接租用柜门按钮 */}
      <Button onClick={() => setShowComingSoonModal(true)} style={{ width: '218px', height: '46px', background: '#01B596', borderRadius: '23px', margin: '22px auto 20px auto' }}>
        {
          isEnglish ? (
            <>
              <div style={{ fontSize: '18px', fontFamily: 'Squad-SemiBold, Squad', fontWeight: 600, color: '#ACACAC', position: 'absolute', width: '80%', textAlign: 'center', marginTop: '2px', zIndex: 1 }}>
                Coming Soon
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: '18px', fontFamily: 'PingFangSC-Medium, PingFang SC', fontWeight: 500, color: '#ACACAC', position: 'absolute', width: '80%', textAlign: 'center', marginTop: '2px', zIndex: 1 }}>
                即将上线
              </div>
            </>
          )
        }
        <div style={{ width: '218px', height: '46px', backgroundColor: '#000000', position: 'absolute', borderRadius: '36px', opacity: 0.7 }}>
        </div>
      </Button>
    </>
  );
};

export interface Props {
  cabId32Str: string;
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  selectedPlatform?: number;
  setSelectedPlatform: (platform?: number) => void;
}

export default SelectPlatform;
